export const DEFAULT_FREQUENCY_LIMIT = 3;
export const DISABLE_FREQUENCY_CAPPING = "DISABLE_FREQUENCY_CAPPING"; // This id can be used to disable frequency capping
export const DEFAULT_FREQUENCY_CAP_VALUE = {
    id: "",
    counterValue: 0,
    sessionId: "",
};

/**
 * Enum representing the visibility options for session-based frequency capping.
 */
export enum SessionVisibility {
    /**
     * The action should be performed only once per session.
     */
    ONCE_PER_SESSION = "ONCE_PER_SESSION",

    /**
     * The action should be performed every time during the session.
     */
    EVERYTIME_PER_SESSION = "EVERYTIME_PER_SESSION",
}

/**
 * Enum to define modes for determining the eligibility of modals/half-cards to proceed.
 */
export enum ProceedMode {
    /**
     * Checks if only a single modal/half-card is eligible and returns true/false.
     * Does not update local storage.
     */
    ONLY_CHECK = "ONLY_CHECK",

    /**
     * Checks eligibility of modals/half-cards and returns true/false.
     * Updates local storage if multiple modals/half-cards are eligible,
     * ensuring they do not appear in subsequent iterations.
     */
    CHECK_AND_UPDATE = "CHECK_AND_UPDATE",
}
